import { useEffect, useState } from "react";
import { Loader2, MapPin, Users, Target } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Avatar } from "@/components/common/ui";

const CAT = { "Community Integration": "#12B76A", Recreation: "#155EEF", Education: "#7C3AED", Social: "#F79009", Wellness: "#0EA5E9", Employment: "#DB2777" };

export default function Activities() {
  const [acts, setActs] = useState(null);
  useEffect(() => { api.get("/activities").then((r) => setActs(r.data)).catch(() => setActs([])); }, []);
  if (!acts) return <div className="flex h-64 items-center justify-center text-muted-foreground"><Loader2 className="animate-spin" /></div>;

  return (
    <div>
      <PageHeader overline="Care · Person-Centered" title="Activities & Community Integration"
        description="Choice, autonomy and dignity. Every activity links to ISP goals and community engagement outcomes." />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {acts.map((a, i) => {
          const col = CAT[a.category] || "#155EEF";
          return (
            <div key={a.id} data-testid={`activity-${a.id}`} className="careiq-rise rounded-xl border bg-card p-4 shadow-sm" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="flex items-center justify-between">
                <span className="rounded-full px-2.5 py-0.5 text-xs font-semibold" style={{ color: col, backgroundColor: col + "1a" }}>{a.category}</span>
                {a.isp_linked && <span className="flex items-center gap-1 text-[11px] font-medium text-[#7C3AED]"><Target size={12} /> ISP-linked</span>}
              </div>
              <h3 className="mt-2 font-semibold">{a.name}</h3>
              <div className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground"><MapPin size={12} /> {a.location} · {a.date}</div>
              <div className="mt-3 flex items-center gap-2 border-t pt-3">
                <div className="flex -space-x-2">
                  {a.participants.slice(0, 5).map((p, j) => <span key={j} className="ring-2 ring-card rounded-full"><Avatar name={p.name} seed={j} size={26} /></span>)}
                </div>
                <span className="flex items-center gap-1 text-xs text-muted-foreground"><Users size={12} /> {a.participants.length} participants</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
